import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { JSONTree } from 'react-json-tree';
import { stringify } from 'javascript-stringify';
import { css } from '@emotion/react';
import getItemString from './getItemString.js';
import getJsonTreeTheme from './getJsonTreeTheme.js';
function stringifyAndShrink(val, isWideLayout) {
    if (val === null) {
        return 'null';
    }
    const str = stringify(val);
    if (typeof str === 'undefined') {
        return 'undefined';
    }
    if (isWideLayout)
        return str.length > 42 ? str.substr(0, 30) + '…' + str.substr(-10) : str;
    return str.length > 22 ? `${str.substr(0, 15)}…${str.substr(-5)}` : str;
}
const expandFirstLevel = (keyName, data, level) => level <= 1;
function prepareDelta(value) {
    if (value && value._t === 'a') {
        const res = {};
        for (const key in value) {
            if (key !== '_t') {
                if (key[0] === '_' && !value[key.substr(1)]) {
                    res[key.substr(1)] = value[key];
                }
                else if (value['_' + key]) {
                    res[key] = [value['_' + key][0], value[key][0]];
                }
                else if (!value['_' + key] && key[0] !== '_') {
                    res[key] = value[key];
                }
            }
        }
        return res;
    }
    return value;
}
const diffCss = (theme) => ({
    padding: '2px 3px',
    borderRadius: '3px',
    position: 'relative',
    color: theme.TEXT_COLOR,
});
const diffWrapCss = css({ position: 'relative', zIndex: 1 });
export default class JSONDiff extends Component {
    constructor() {
        super(...arguments);
        this.state = { data: {} };
        this.getItemString = (type, data) => getItemString(type, data, this.props.dataTypeKey, this.props.isWideLayout, true);
        this.valueRenderer = (raw, value) => {
            const { isWideLayout } = this.props;
            if (Array.isArray(value)) {
                switch (value.length) {
                    case 1:
                        return (_jsx("span", { css: diffWrapCss, children: _jsx("span", { css: [
                                    diffCss,
                                    (theme) => ({ backgroundColor: theme.DIFF_ADD_COLOR }),
                                ], children: stringifyAndShrink(value[0], isWideLayout) }, "diffAdd") }));
                    case 2:
                        return (_jsxs("span", { css: diffWrapCss, children: [_jsx("span", { css: [
                                        diffCss,
                                        (theme) => ({
                                            textDecoration: 'line-through',
                                            backgroundColor: theme.DIFF_REMOVE_COLOR,
                                        }),
                                    ], children: stringifyAndShrink(value[0], isWideLayout) }, "diffUpdateFrom"), _jsx("span", { css: [diffCss, (theme) => ({ color: theme.DIFF_ARROW_COLOR })], children: ' => ' }, "diffUpdateArrow"), _jsx("span", { css: [
                                        diffCss,
                                        (theme) => ({ backgroundColor: theme.DIFF_ADD_COLOR }),
                                    ], children: stringifyAndShrink(value[1], isWideLayout) }, "diffUpdateTo")] }));
                    case 3:
                        return (_jsx("span", { css: diffWrapCss, children: _jsx("span", { css: [
                                    diffCss,
                                    (theme) => ({
                                        textDecoration: 'line-through',
                                        backgroundColor: theme.DIFF_REMOVE_COLOR,
                                    }),
                                ], children: stringifyAndShrink(value[0]) }, "diffRemove") }));
                }
            }
            return raw;
        };
    }
    componentDidMount() {
        this.updateData();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.delta !== this.props.delta) {
            this.updateData();
        }
    }
    updateData() {
        // this magically fixes weird React error, where it can't find a node in tree
        // if we set `delta` as JSONTree data right away
        // https://github.com/alexkuz/redux-devtools-inspector/issues/17
        this.setState({ data: this.props.delta });
    }
    render() {
        const { base16Theme, ...props } = this.props;
        if (!this.state.data) {
            return (_jsx("div", { css: (theme) => ({
                    padding: '10px',
                    color: theme.TEXT_PLACEHOLDER_COLOR,
                }), children: "(states are equal)" }));
        }
        return (_jsx(JSONTree, { ...props, theme: getJsonTreeTheme(base16Theme), data: this.state.data, getItemString: this.getItemString, valueRenderer: this.valueRenderer, postprocessValue: prepareDelta, isCustomNode: Array.isArray, shouldExpandNodeInitially: expandFirstLevel, hideRoot: true }));
    }
}
